import React, { memo, useState } from 'react';
import { TextField, Typography, Box, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';

function InputField({
  name,
  placeholder,
  id,
  size,
  type,
  value,
  onChange = () => {},
  onBlur = () => {},
  state,
  disable,
  required,
  endAdornment,
  style,
  inputRef,
  onKeyDown,
  autoFocus,
  from,
  maxLength = 50,
  InputProps,
  onFocus = () => {},
}) {
  const [showPassword, setshowPassword] = useState(false);
  const [focus, setFocus] = useState(false);
  endAdornment =
    type == 'password' ? (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => setshowPassword((prev) => !prev)}
          edge="end"
          className="adornmentIconBtn"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ) : (
      ''
    );

  function handleOnFocus(e) {
    setFocus(true);
    onFocus(e);
  }
  function handleOnBlur(e) {
    setFocus(false);
    onBlur(e);
  }
  console.log(state, 'stateeee');
  return (
    <Box>
      <TextField
        autoFocus={name == 'itemName' || autoFocus}
        error={state?.errorStatus[name] === true ? true : false}
        id={id == undefined ? placeholder : id}
        name={name}
        autoComplete={'new-password'}
        label={placeholder}
        variant="outlined"
        disabled={disable}
        size={size}
        type={showPassword ? 'text' : type}
        fullWidth
        required={required}
        value={value}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        onChange={onChange}
        // onKeyDown={onKeyDown}
        onKeyDown={onKeyDown}
        InputProps={{
          endAdornment: endAdornment,

          ...InputProps,
        }}
        inputProps={{
          maxLength: maxLength,
        }}
        InputLabelProps={{
          shrink: value || focus ? true : false,
        }}
        sx={{
          '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
            borderColor: 'input.border',
          },
          '& input::-ms-reveal, & input::-ms-clear': {
            display: 'none',
          },
          '& input::-webkit-credentials-auto-fill-button': {
            visibility: 'hidden',
            display: 'none !important',
          },
          '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
            color: 'input.font',
          },
          '.MuiFormLabel-asterisk': {
            color: 'danger.main',
            fontSize: '20px',
            fontWeight: 'bold',
          },
          // minHeight:(name === 'legalname' ? '50px':'0px')
        }}
        inputRef={inputRef}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
          // minHeight: "16px",
        }}
      >
        {name === 'pan' && state.errorStatus['pan'] === true ? state?.errorFields['pan'] : state?.errorFields[name]}
      </Typography>
    </Box>
  );
}

export default memo(InputField);
